import { IconButton, ListItem } from '@hvcgroep/design-system';
import * as React from 'react';
import { APP_ID, saveConstants } from '../../config/constants';
import AppNegotiator from '../AppNegotiator';
import defaultOptions from '../../../defaultOptions';

const localStorageUid = 'hvc-selected-widget';

const AppSelector = () => {
  const [selectedWidget, setSelectedWidget] = React.useState<string | null>();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, callback: Function) => {
    e.preventDefault();
    callback();

    localStorage.setItem(localStorageUid, String(APP_ID));
    setSelectedWidget(String(APP_ID));
  };

  React.useEffect(() => {
    if (localStorage.getItem(localStorageUid)) {
      saveConstants(defaultOptions[String(localStorage.getItem(localStorageUid))]);
      setSelectedWidget(APP_ID);
    }
  }, []);

  if (selectedWidget) {
    return (
      <>
        <AppNegotiator id={APP_ID} />
        <IconButton
          icon="keyboard_arrow_left"
          onClick={() => {
            localStorage.removeItem(localStorageUid);
            window.location.reload();
          }}
          // @ts-expect-error
          style={{ position: 'fixed', top: 30, left: 30 }}
        />
      </>
    );
  }

  return (
    <div>
      <h1>Select a widget</h1>
      <ListItem
        title="Afvalkalender"
        icon={<div />}
        onClick={(e) => handleClick(e, () => saveConstants(defaultOptions['waste-calendar']))}
        link="/"
        className="my-4"
      />
      <ListItem
        title="Warmte aanmeldstraat"
        icon={<div />}
        onClick={(e) => handleClick(e, () => saveConstants(defaultOptions['registration-desk']))}
        className="my-4"
        link="/"
      />
      <ListItem
        title="Containerkaart"
        icon={<div />}
        onClick={(e) => handleClick(e, () => saveConstants(defaultOptions['container-locations']))}
        link="/"
        className="my-4"
      />
      <ListItem
        title="Warmtecalculator"
        icon={<div />}
        onClick={(e) => handleClick(e, () => saveConstants(defaultOptions['heat-calculator']))}
        className="my-4"
        link="/"
      />
      <ListItem
        title="Meldingen openbare ruimte"
        icon={<div />}
        onClick={(e) => handleClick(e, () => saveConstants(defaultOptions.reports))}
        className="my-4"
        link="/"
      />
      <ListItem
        title="Measurements"
        icon={<div />}
        onClick={(e) => handleClick(e, () => saveConstants(defaultOptions.measurements))}
        className="my-4"
        link="/"
      />
    </div>
  );
};

export default AppSelector;
